import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import Card from "./Card.js";
import url from "../configs/config";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Box } from "@mui/material";
import * as SettingSelector from "../store/setting/selectors";
import { useSelector } from "react-redux";
import AlertNotificationSimple from "./alert/alert-notification-simple";
import FadeLoaderComponent from "./loader-component";
import { roleTypes } from "../data/roleType";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const HistoryCard = ({ item }) => {
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${month}/${day}/${year} ${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${ampm}`;
  };

  return (
    <Card style={{ width: "40vw" }}>
      <div
        className="border-2 shadow-sm"
        style={{ transition: "box-shadow 0.2s" }}
      >
        <div className="d-flex flex-row p-3 p-sm-4">
          <div style={{ width: "70%" }}>
            <div className="">
              <div
                className="text-capitalize fw-bold mb-1"
                style={{ fontSize: "0.875rem" }}
              >
                {item.type}
                <span className={`fw-bold text-capitalize`}>
                  {" "}
                  {item.type === "order"
                    ? "Received"
                    : item.type === "job" && item.job === "Job Unassigned"
                      ? "Unassigned"
                      : "Changed"}
                  <span
                    className="text-muted text-normal fw-normal small mb-0"
                    style={{ fontSize: "0.875rem" }}
                  >
                    {" "}
                    (by {item.name})
                  </span>
                </span>
              </div>
              <p
                className="text-muted fw-normal small mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                Status{" "}
                <span
                  className={`fw-bold text-capitalize ${
                    item.status === "active" || item.status === "installed"
                      ? "text-success"
                      : item.status === "damaged"
                      ? "text-danger"
                      : "text-dark"
                  }`}
                >
                  {item.status}
                </span>
              </p>
            </div>
          </div>

          <div style={{ width: "30%" }}>
            <div className="text-muted small mb-1">Date:</div>
            <div className="text-muted small mb-1">
              {formatDateTime(item.date)}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-start px-3 px-sm-4 pb-3 pb-sm-4">
          <div style={{ width: "70%" }}>
            <div className="text-muted small mb-1">
              {" "}
              From:{" "}
              <span
                className="text-muted text-capitalize small  mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                {item?.type === "order" && "PO# "}
                {item.received_from}
              </span>
            </div>

            <div className="text-muted small mb-1">
              To:{" "}
              <span
                className="text-muted text-capitalize small  mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                {item?.received_to}
              </span>
            </div>
          </div>

          <div style={{ width: "30%" }}>
            <div className="text-muted small mb-1">
              <span
                className="text-muted small mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                Job: {item.job === "Job Unassigned" ? "N/A" : item.job}
              </span>
            </div>
            <div className="text-muted small mb-1">
              <span
                className="text-muted small mb-0"
                style={{ fontSize: "0.875rem" }}
              >
                Warehouse: {item.warehouse_name}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

const JobProducts = ({ jobId, isCompleted, isCollapsed, onToggleCollapse }) => {
  const token = localStorage.getItem("coyote-token");
  const navigate = useNavigate();
  const pickerRef = useRef(null);
  const alertRefProduct = useRef(null);
  const apiCallInProgress = useRef(false);
  const [errors, setErrors] = useState({});
  const [decodedToken, setDecodedToken] = useState();
  const [jobProducts, setJobProducts] = useState([]);
  const [viewProduct, setViewProduct] = useState(true);
  const [productItems, setProductItems] = useState([]);
  const [hasProducts, setHasProducts] = useState(false);
  const [itemsLoader, setItemsLoader] = useState(true);
  const [productsLoader, setProductsLoader] = useState(true);
  const [selectedHistory, setSelectedHistory] = useState([]);
  const [showHistoryView, setShowHistoryView] = useState(false);
  const [selectedItemProduct, setSelectedItemProduct] = useState({});
  const [isCollapsedProduct, setIsCollapsedProduct] = useState(false);
  const [totalJobProductsRecords, setTotalJobProductsRecords] = useState(0);
  const [jobProductsPagination, setJobProductsPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [jobProductsGlobalFilter, setJobProductsGlobalFilter] = useState("");
  const [productItemsGlobalFilter, setProductItemsGlobalFilter] = useState("");
  const permissions = useSelector(SettingSelector.set_permissions);
  const productReportHasViewPermission =
    permissions?.job?.view_job_product_report === true;
  const jobItemStatusHasUpdatePermission =
    permissions?.job?.update_job_item_status === true;
  const [alerts, setAlerts] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [assignedDateRange, setAssignedDateRange] = useState({
    assignDateFrom: "",
    assignDateTo: "",
  });
  const [dateRange, setDateRange] = useState([
    {
      startDate: assignedDateRange.assignDateFrom
        ? new Date(assignedDateRange.assignDateFrom)
        : new Date(),
      endDate: assignedDateRange.assignDateTo
        ? new Date(assignedDateRange.assignDateTo)
        : new Date(),
      key: "selection",
    },
  ]);

  const handleItemsClose = () => {
    setSelectedItemProduct(null);
    setViewProduct(true);
    setProductItems([]);
    setShowHistoryView(false);
    setSelectedHistory([]);
  };

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      getJobProducts().then((products) => {
        setHasProducts(products?.length > 0);
      });
    }
  }, [jobId]);

  const dateRangeFilterFn = (row, columnId, filterValue) => {
    if (!filterValue?.assignDateFrom && !filterValue?.assignDateTo) return true;
    const rowDate = new Date(row.getValue(columnId));
    const start = filterValue.assignDateFrom
      ? new Date(filterValue.assignDateFrom)
      : null;
    const end = filterValue.assignDateTo
      ? new Date(filterValue.assignDateTo)
      : null;
    if (start) {
      start.setHours(0, 0, 0);
    }
    if (end) {
      end.setHours(23, 59, 59, 999);
    }

    if (start && end) return rowDate >= start && rowDate <= end;
    if (start) return rowDate >= start;
    if (end) return rowDate <= end;
    return true;
  };

  const handleError = (err, alertFor) => {
    const { response } = err;

    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          )
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      const responseErrors = response?.data?.error || {};
      setErrors(responseErrors);
      if (
        err?.response?.data?.message !==
        "You are not allowed to update this warehouse"
      ) {
        setAlerts({
          message: response ? response.data.message : "An error occurred",
          type: "danger",
          show: true,
          alertFor,
        });
        setTimeout(() => {
          if (response?.data?.message === "Warehouse not found") {
            window.location.href = "/dashboard/app/job-list";
          }
          setAlerts({ show: false, alertFor: "", message: "", type: "" });
        }, 5000);
      }
    }
  };

  const handleHistoryClick = (historyData) => {
    setSelectedHistory(historyData);
    setShowHistoryView(true);
  };

  const getJobProducts = async () => {
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          )
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      return;
    }

    if (apiCallInProgress.current) return;
    apiCallInProgress.current = true;
    setProductsLoader(true);

    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const response = await axios.get(
        `${url.backendURL}job/${jobId}/products`,
        config
      );
      const products = response?.data?.response?.data?.products || [];
      setJobProducts(products);
      return products;
    } catch (err) {
      if (alertRefProduct?.current) {
        alertRefProduct.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "jobs");
    } finally {
      apiCallInProgress.current = false;
      setProductsLoader(false);
    }
  };

  const handleItemsClick = async (product) => {
    setViewProduct(false);
    await getProductItems(product);
  };

  const jobProductColumns = useMemo(
    () => [
      
      {
        id: "quantity",
        header: "Quantity",
        size: 100,
        accessorFn: (row) => (Array.isArray(row.items) ? row.items.length : 0),
        enableSorting: true,
        sortingFn: (rowA, rowB, columnId) => {
          const a = rowA.getValue(columnId) ?? 0;
          const b = rowB.getValue(columnId) ?? 0;
          if (a === b) return 0;
          return a > b ? 1 : -1;
        },
        Cell: ({ row }) =>
          Array.isArray(row.original.items) ? row.original.items.length : 0,
      },
      { accessorKey: "make", header: "Make", size: 150 },
      { accessorKey: "model", header: "Model", size: 150 },
      { accessorKey: "description", header: "Description", size: 200 },
      {
        accessorKey: "searchable_text",
        header: "Searchable Text",
        size: 0,
        enableHiding: true,
        enableColumnFilter: false,
        enableGlobalFilter: true,
        muiTableHeadCellProps: {
          sx: { display: "none" },
        },
        muiTableBodyCellProps: {
          sx: { display: "none" },
        },
      },
      { accessorKey: "sku", header: "SKU", size: 150 },
      {
        header: "Items",
        size: 150,
        Cell: ({ cell }) => {
          return (
            <a
              onClick={async () => {
                setSelectedItemProduct(cell.row.original);
                handleItemsClick(cell.row.original);
              }}
              style={{
                color: "blue",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                textDecoration: "underline",
              }}
            >
              View Items
            </a>
          );
        },
      },
    ],
    []
  );

  const getProductItems = async (product) => {
    if (!token) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          )
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "invalid-token" },
        }
      );
      return;
    } else {
      setItemsLoader(true);
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      try {
        const response = await axios.get(
          `${url.backendURL}job/${jobId}/products/${product.product_id}`,
          config
        );
        const allItems = response.data.response.data;
        setProductItems(allItems);
      } catch (err) {
        if (alertRefProduct.current) {
          alertRefProduct.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          setProductItems([]);
        }
        handleError(err, "products");
      } finally {
        setItemsLoader(false);
      }
    }
  };

  const jobProductsTableProps = {
    enableFullScreenToggle: false,
    muiSelectCheckboxProps: {
      color: "secondary",
    },
    muiTableContainerProps: {
      sx: {
        minHeight: "320px",
      },
    },
    state: {
      pagination: jobProductsPagination,
      globalFilter: jobProductsGlobalFilter,
      isLoading: productsLoader,
    },
    manualPagination: true,
    manualFiltering: false,
    enableFilterMatchHighlighting: false,
    onPaginationChange: setJobProductsPagination,
    onGlobalFilterChange: setJobProductsGlobalFilter,
    rowCount: totalJobProductsRecords,
  };

  const toggleCollapseProduct = () => {
    setIsCollapsedProduct((prev) => !prev);
  };

  const getJobProductsPaginatedData = (data, pageIndex, pageSize) => {
    const startIndex = pageIndex * pageSize;
    const endIndex = startIndex + pageSize;
    return data.slice(startIndex, endIndex);
  };

  const filterJobProducts = (jobProducts, searchValue) => {
    let filteredJobProducts = jobProducts;

    if (assignedDateRange.assignDateFrom && assignedDateRange.assignDateTo) {
      const startDate = assignedDateRange.assignDateFrom
        ? new Date(assignedDateRange.assignDateFrom)
        : null;
      const endDate = assignedDateRange.assignDateTo
        ? new Date(assignedDateRange.assignDateTo)
        : null;

      filteredJobProducts = jobProducts
        .map((product) => {
          const items =
            product.items?.filter((item) => {
              if (!item.assigned_date) return false;
              const itemDate = new Date(item.assigned_date);

              itemDate.setHours(0, 0, 0, 0);
              if (startDate) startDate.setHours(0, 0, 0, 0);
              if (endDate) endDate.setHours(0, 0, 0, 0);
              if (startDate && itemDate < startDate) return false;
              if (endDate && itemDate > endDate) return false;
              return true;
            }) || [];
          return { ...product, items };
        })
        .filter((product) => product.items.length > 0);
    }

    if (!searchValue || searchValue.trim() === "") {
      return filteredJobProducts;
    }

    const searchWords = searchValue
      .toLowerCase()
      .trim()
      .replace(/[-+]/g, "")
      .split(/\s+/);

    return filteredJobProducts.filter((product) => {
      const quantity = Array.isArray(product.items)
        ? product.items.length.toString()
        : "0";
      const searchableText =
        (product.searchable_text || "").toLowerCase() + ` ${quantity}`;

      return searchWords.every((word) => searchableText.includes(word));
    });
  };

  const safeJobProducts = Array.isArray(jobProducts) ? jobProducts : [];
  const enhancedJobProducts = useMemo(() => {
    const filteredProducts = filterJobProducts(
      safeJobProducts,
      jobProductsGlobalFilter
    );

    setTotalJobProductsRecords(filteredProducts.length);

    const paginatedProducts = getJobProductsPaginatedData(
      filteredProducts,
      jobProductsPagination.pageIndex,
      jobProductsPagination.pageSize
    );

    return paginatedProducts.map((product) => ({
      ...product,
    }));
  }, [
    safeJobProducts,
    jobProductsGlobalFilter,
    jobProductsPagination.pageIndex,
    jobProductsPagination.pageSize,
    assignedDateRange,
  ]);

  const tableJobProduct = useMaterialReactTable({
    ...jobProductsTableProps,
    columns: jobProductColumns,
    data: enhancedJobProducts,

    getRowId: (originalRow) => `warehouse-product-${originalRow.id}`,
    muiTableBodyRowProps: ({ row, table }) => {
      const warehouseRows = table
        .getRowModel()
        .rows.filter((r) => r.original?.product_selection === "warehouse");

      const lastWarehouseRowId = warehouseRows[warehouseRows.length - 1]?.id;
      const isLastWarehouseRow = row.id === lastWarehouseRowId;

      return {
        sx: {
          backgroundColor:
            row.original?.product_selection === "warehouse"
              ? "#ecf2f9c2"
              : "inherit",
          ...(isLastWarehouseRow
            ? {
                borderBottom: "2px solid #d1d7dccc",
                boxShadow: "0px 6px 13px #d1d7dccc, 0px 12px 18px #d1d7dccc",
              }
            : {}),
        },
      };
    },
    muiTablePaperProps: {
      sx: {
        position: "relative",
        overflow: "visible",
      },
      sm: {
        borderBottom: "2px solid #d1d7dccc",
        boxShadow: "0px 6px 13px #d1d7dccc, 0px 12px 18px #d1d7dccc",
      },
    },
    renderEmptyRowsFallback: () => (
      <>
        {productsLoader ? (
          <div style={{ textAlign: "center", padding: "2rem" }}>
            <FadeLoaderComponent />
          </div>
        ) : assignedDateRange.assignDateFrom ||
          assignedDateRange.assignDateTo ||
          jobProductsGlobalFilter !== "" ? (
          <p style={{ textAlign: "center", padding: "2rem", color: "#666" }}>
            No materials found. Try adjusting your date selection or search
            criteria
          </p>
        ) : (
          <p style={{ textAlign: "center", padding: "2rem", color: "#666" }}>
            No materials have been transferred to this project yet
          </p>
        )}
      </>
    ),

    enableGlobalFilterModes: false,
    muiTableBodyCellProps: {
      sx: {
        "& mark": {
          backgroundColor: "transparent",
          color: "inherit",
        },
      },
    },
  });

  const status = [
    { value: "active", label: "Active" },
    { value: "in-active", label: "Inactive" },
    { value: "damaged", label: "Damaged" },
    { value: "repaired", label: "Repaired" },
    { value: "installed", label: "Installed" },
  ];

  const jobProductItemsColumns = useMemo(
    () => [
      {
        accessorKey: "po_number",
        header: "PO Number",
        size: 120,
        enableEditing: false,
      },
      {
        accessorKey: "notes",
        header: "Notes",
        size: 180,
        enableEditing: false,
      },
      {
        accessorKey: "assigned_date",
        header: "Assigned Date",
        size: 180,
        enableEditing: false,
        filterFn: dateRangeFilterFn,
        Cell: ({ row }) => {
          const date = row.original.assigned_date;
          return date
            ? new Date(date).toLocaleDateString("en-US", {
                month: "numeric",
                day: "numeric",
                year: "numeric",
              })
            : "-";
        },
      },
      {
        accessorKey: "assigned_from_warehouse",
        header: "Assigned From Warehouse",
        size: 180,
        enableEditing: false,
        Cell: ({ row }) => {
          const assignedFromWarehouse = row.original.assigned_from_warehouse;
          return assignedFromWarehouse ? assignedFromWarehouse : "-";
        },
      },
      {
        accessorKey: "assigned_by",
        header: "Assigned By",
        size: 180,
        enableEditing: false,
        Cell: ({ row }) => {
          const assignedBy = row.original.assigned_by;
          return assignedBy ? assignedBy : "-";
        },
      },
      {
        accessorKey: "history",
        header: "History",
        size: 180,
        enableEditing: false,
        Cell: ({ cell }) => {
          const history = cell.getValue();
          const rowData = cell.row.original;
          const firstHistory =
            Array.isArray(history) && history.length > 0 ? history[0] : null;
          if (!firstHistory) {
            return (
              <span
                style={{
                  fontStyle: "italic",
                  color: "#9ca3af",
                  fontSize: "11px",
                  display: "flex",
                  alignItems: "center",
                  height: "32px",
                }}
              >
                No History
              </span>
            );
          }
          const getStatusColor = (status) => {
            switch (status?.toLowerCase()) {
              case "active":
                return "#10b981";
              case "pending":
                return "#f59e0b";
              case "completed":
                return "#3b82f6";
              default:
                return "#6b7280";
            }
          };

          return (
            <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <div
                onClick={() => handleHistoryClick(history)}
                style={{
                  fontSize: "11px",
                  padding: "6px 8px",
                  backgroundColor: "#ffffff",
                  borderRadius: "6px",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "3px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "600",
                      color: "#111827",
                      textTransform: "capitalize",
                    }}
                  >
                    {firstHistory.type}
                  </span>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {firstHistory.notes && (
                      <span
                        style={{
                          width: "6px",
                          height: "6px",
                          backgroundColor: "#f59e0b",
                          borderRadius: "50%",
                          display: "inline-block",
                        }}
                        title="Has Notes"
                      ></span>
                    )}
                    <span
                      style={{
                        fontSize: "9px",
                        padding: "2px 6px",
                        borderRadius: "10px",
                        textTransform: "capitalize",
                        backgroundColor:
                          getStatusColor(firstHistory.status) + "20",
                        color: getStatusColor(firstHistory.status),
                        fontWeight: "500",
                      }}
                    >
                      {firstHistory.status}
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    color: "#4b5563",
                    fontSize: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    marginBottom: "2px",
                  }}
                >
                  <span style={{ fontWeight: "500" }}>
                    {firstHistory.type === "order" && "PO# "}

                    {firstHistory.received_from && firstHistory.received_from}
                  </span>
                  {firstHistory.received_from && (
                    <span style={{ color: "#9ca3af" }}>→</span>
                  )}
                  <span>
                    {firstHistory.received_to && firstHistory.received_to}
                  </span>
                </div>

                <div
                  className="bg-none"
                  style={{
                    color: "#9ca3af",
                    fontSize: "9px",
                    fontWeight: "400",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    {new Date(firstHistory.date).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "2-digit",
                    })}
                  </span>
                  <span className="text-primary fw-bold">Click to view</span>
                </div>
              </div>
            </div>
          );
        },
      },
      {
        accessorKey: "status",
        header: "Status",
        editVariant: "select",
        size: 50,
        editSelectOptions: ({ row }) => {
          const currentStatus = row.original.status;
          return status.map((s) => ({
            ...s,
            disabled:
              (decodedToken?.roles?.every(
                (role) => role.role_type !== roleTypes.SUPER_ADMIN
              ) &&
                !jobItemStatusHasUpdatePermission) ||
              isCompleted ||
              currentStatus === "installed" ||
              (s.value === "installed" && currentStatus !== "active"),
          }));
        },
        muiEditTextFieldProps: ({ cell, row, table }) => {
          const [itemProduct, setItemProduct] = useState(selectedItemProduct);
          const [isSubmittingStatus, setIsSubmittingStatus] = useState(false);
          const [successStatusLoader, setSuccessStatusLoader] = useState(false);
          const [errorStatusLoader, setErrorStatusLoader] = useState(false);
          const [errorMessage, setErrorMessage] = useState("");
          const [successMessage, setSuccessMessage] = useState("");
          const [statusValue, setStatusValue] = useState(cell.getValue());
          const currentValue = cell.getValue() || "";

          const submitStatus = async (newStatus, itemId, cell) => {
            if (isSubmittingStatus || isCompleted) return;
            setSuccessStatusLoader(false);
            setErrorStatusLoader(false);
            try {
              setIsSubmittingStatus(true);
              setErrorMessage("");
              setSuccessMessage("");

              const config = {
                headers: {
                  Authorization: `${token}`,
                },
              };

              const data = {
                status: newStatus,
              };

              await axios.put(
                `${url.backendURL}job/${jobId}/products/${itemProduct.product_id}/item/${itemId}/status`,
                data,
                config
              );

              setIsSubmittingStatus(false);
              setSuccessStatusLoader(true);
              setSuccessMessage("Status updated successfully");
              await getProductItems(selectedItemProduct);

              setErrorStatusLoader(false);
              setTimeout(() => {
                setSuccessStatusLoader(false);
                setSuccessMessage("");
              }, 3000);
            } catch (err) {
              console.error("Error updating status:", err);
              if (alertRefProduct.current) {
                alertRefProduct.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
              handleError(err, "products");
              setSuccessStatusLoader(false);

              let errorMsg = "Failed to update status";
              if (err.response?.status === 401) {
                errorMsg = "Unauthorized access";
              } else if (err.response?.status === 404) {
                errorMsg = "Item not found";
              } else if (err.response?.status === 500) {
                errorMsg = "Server error occurred";
              } else if (err.response?.data?.message) {
                errorMsg = err.response.data.message;
              } else if (err.message) {
                errorMsg = err.message;
              }

              setStatusValue(cell.getValue() || "");
              setErrorStatusLoader(true);
              setErrorMessage(errorMsg);
              setIsSubmittingStatus(false);

              setTimeout(() => {
                setErrorMessage("");
              }, 5000);
            }
          };

          return {
            select: true,
            value: currentValue,
            disabled:
              isCompleted ||
              row.original.status === "installed" ||
              isSubmittingStatus ||
              (decodedToken?.roles?.every(
                (role) => role.role_type !== roleTypes.SUPER_ADMIN
              ) &&
                !jobItemStatusHasUpdatePermission),
            error: errorStatusLoader,
            helperText: errorMessage,

            sx: {
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none !important",
                },
                "&.Mui-focused fieldset": {
                  border: "none !important",
                },
                "&.Mui-error fieldset": {
                  border: "none !important",
                },
              },

              backgroundColor: "none",

              "& .MuiSelect-select": {
                padding: "8px 12px",
                fontSize: "14px",
                color: errorStatusLoader
                  ? "#dc2626"
                  : successStatusLoader
                  ? "#059669"
                  : "#374151",
                backgroundColor: "none",
              },

              "& .MuiSelect-icon": {
                color: errorStatusLoader
                  ? "#ef4444 !important"
                  : successStatusLoader
                  ? "#10b981 !important"
                  : "#6b7280 !important",
                transition: "color 0.2s ease-in-out",
              },

              "& .MuiFormHelperText-root": {
                color: errorStatusLoader
                  ? "#dc2626"
                  : successStatusLoader
                  ? "#059669"
                  : "#6b7280",
                fontSize: "12px",
                marginLeft: "12px",
                fontWeight:
                  errorStatusLoader || successStatusLoader ? "500" : "400",
                marginTop: "4px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
              "&.Mui-error .MuiFormHelperText-root": {
                color: "#dc2626 !important",
              },

              "& .MuiPaper-root": {
                border: "none",
              },
            },

            style: {
              position: "relative",
            },

            InputProps: {
              style: {
                position: "relative",
              },
              endAdornment: isSubmittingStatus ? (
                <div
                  style={{
                    position: "absolute",
                    right: "30px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    zIndex: 1,
                  }}
                >
                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      border: "2px solid #e5e7eb",
                      borderTop: "2px solid #3b82f6",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                </div>
              ) : null,
            },

            FormHelperTextProps: {
              sx: {
                color: errorStatusLoader
                  ? "#dc2626"
                  : successStatusLoader
                  ? "#059669"
                  : "#6b7280",
                fontSize: "12px",
                fontWeight:
                  errorStatusLoader || successStatusLoader ? "500" : "400",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              },
            },

            onChange: async (event) => {
              const newStatus = event.target.value;
              setStatusValue(newStatus);
              await submitStatus(newStatus, row.original.item_id, cell);
            },
          };
        },
        muiTableBodyCellProps: {
          sx: {
            "&:hover": {
              outline: "none !important",
              border: "none !important",
              boxShadow: "none !important",
            },
          },
        },
      },
    ],
    [jobProducts, selectedItemProduct, alertRefProduct]
  );

  const jobProductsItemsTableProps = {
    enableFullScreenToggle: false,
    enableColumnFilters: true,
    onGlobalFilterChange: setProductItemsGlobalFilter,
    enableFilterMatchHighlighting: false,
    muiSelectCheckboxProps: {
      color: "secondary",
    },
    muiTableContainerProps: {
      sx: {
        minHeight: "320px",
      },
    },
    state: {
      isLoading: itemsLoader,
    },
  };

  const normalizeText = (text) =>
    text
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const filterJobProductItems = (jobProductItems, searchValue) => {
    let filteredJobProductItems = jobProductItems;

    if (assignedDateRange.assignDateFrom && assignedDateRange.assignDateTo) {
      const startDate = assignedDateRange.assignDateFrom
        ? new Date(assignedDateRange.assignDateFrom)
        : null;
      const endDate = assignedDateRange.assignDateTo
        ? new Date(assignedDateRange.assignDateTo)
        : null;

      filteredJobProductItems = jobProductItems?.filter((item) => {
        if (!item.assigned_date) return false;
        const itemDate = new Date(item.assigned_date);

        itemDate.setHours(0, 0, 0, 0);
        if (startDate) startDate.setHours(0, 0, 0, 0);
        if (endDate) endDate.setHours(0, 0, 0, 0);
        if (startDate && itemDate < startDate) return false;
        if (endDate && itemDate > endDate) return false;
        return true;
      });
    }

    if (!searchValue || searchValue.trim() === "") {
      return filteredJobProductItems;
    }

    let str = searchValue.toLowerCase().trim();
    str = str.replace(/\bin-active\b/g, "inactive");
    str = str.replace(/[-+/]/g, " ");

    let searchWords = str.split(/\s+/).filter(Boolean);

    const statusText = (text) =>
      text
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, "")
        .replace(/\s+/g, "")
        .trim();

    return filteredJobProductItems.filter((item) => {
      const searchableText =
        normalizeText(`
        ${item.po_number || ""}
        ${item.notes || ""}
        ${item.assigned_date || ""}
        ${item.assigned_from_warehouse || ""}
        ${item.assigned_by || ""}
      `) +
        " " +
        statusText(`${item.status || ""}`);

      return searchWords.every((word) => searchableText.includes(word));
    });
  };

  const safeJobProductItems = Array.isArray(productItems) ? productItems : [];
  const enhancedJobProductItems = useMemo(() => {
    return filterJobProductItems(safeJobProductItems, productItemsGlobalFilter);
  }, [assignedDateRange, safeJobProductItems, productItemsGlobalFilter]);

  const tableJobProductItems = useMaterialReactTable({
    ...jobProductsItemsTableProps,
    columns: jobProductItemsColumns,
    data: enhancedJobProductItems,
    enableEditing: true,
    editDisplayMode: "table",
    createDisplayMode: "row",
    getRowId: (originalRow) => `job-product-item-${originalRow.id}`,
    muiTableContainerProps: {
      sx: {
        overflow: "auto",
      },
    },

    muiTableBodyProps: {
      sx: {
        "& .MuiTableRow-root": {
          position: "relative",
          overflow: "visible",
        },
      },
    },

    muiTableBodyCellProps: {
      sx: {
        overflow: "visible",
        position: "relative",
      },
    },

    muiTablePaperProps: {
      sx: {
        overflow: "visible",
      },
    },
  });

  const clearDateRangeFilter = () => {
    setAssignedDateRange({
      assignDateFrom: "",
      assignDateTo: "",
    });
  };

  const handleDateRangeSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setDateRange([ranges.selection]);
    setAssignedDateRange({
      assignDateFrom: startDate ? format(startDate, "yyyy-MM-dd") : "",
      assignDateTo: endDate ? format(endDate, "yyyy-MM-dd") : "",
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowDatePicker(false);
      }
    };

    if (showDatePicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDatePicker]);

  return (
    <div>
      <div>
        <Form>
          <Row>
            <Col sm={12} ref={alertRefProduct}>
              <Card>
                <Card.Header className="d-flex justify-content-between">
                  <div
                    className="header-title pb-3"
                    style={{ cursor: "pointer" }}
                    onClick={onToggleCollapse}
                  >
                    {viewProduct ? (
                      <div
                        className="breadcrumb header-title"
                        style={{ cursor: "pointer" }}
                      >
                        <h4
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/dashboard/app/job-list");
                          }}
                          className="text-primary card-title"
                          style={{ cursor: "pointer" }}
                        >
                          <span>Job</span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="card-title">Project Materials Report</h4>
                      </div>
                    ) : showHistoryView ? (
                      <div
                        className="breadcrumb header-title"
                        style={{ cursor: "pointer" }}
                      >
                        <h4
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/dashboard/app/job-list");
                          }}
                          className="text-primary card-title"
                          style={{ cursor: "pointer" }}
                        >
                          <span>Job</span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="text-primary card-title cursor-pointer">
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleItemsClose();
                            }}
                          >
                            Project Materials Report
                          </span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="text-primary card-title cursor-pointer">
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowHistoryView(false);
                            }}
                          >
                            Items
                          </span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="card-title">History</h4>
                      </div>
                    ) : (
                      <div
                        className="breadcrumb header-title"
                        style={{ cursor: "pointer" }}
                      >
                        <h4
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/dashboard/app/job-list");
                          }}
                          className="text-primary card-title"
                          style={{ cursor: "pointer" }}
                        >
                          <span>Job</span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="text-primary card-title cursor-pointer">
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleItemsClose();
                            }}
                          >
                            Project Materials Report
                          </span>
                        </h4>
                        <h4 className="mx-2 card-title">{">"}</h4>
                        <h4 className="card-title">Items</h4>
                      </div>
                    )}
                  </div>
                  <div>
                    <div
                      onClick={onToggleCollapse}
                      className="sidebar-toggle"
                      style={{
                        position: "initial",
                        marginRight: "1.5rem",
                        cursor: "pointer",
                      }}
                    >
                      <i
                        className="icon"
                        style={{
                          transform: isCollapsed
                            ? "rotate(270deg)"
                            : "rotate(90deg)",
                        }}
                      >
                        <svg
                          width="20"
                          className="icon-20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.25 12.2744L19.25 12.2744"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                          <path
                            d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </i>
                    </div>
                  </div>
                </Card.Header>
                {!isCollapsed && (
                  <Card.Body>
                    {alerts.alertFor === "products" && (
                      <AlertNotificationSimple
                        type={alerts.type}
                        message={alerts.message}
                        show={alerts.show}
                        onClose={() => setAlerts({ ...alerts, show: false })}
                      />
                    )}

                    {viewProduct && (
                      <Row className="d-flex flex-row">
                        <Col
                          md={12}
                          sm={12}
                          className="m-0 p-0"
                          style={{
                            width: "100%",
                            transition: "width 0.5s ease-in-out",
                            flex: "0 0 auto",
                          }}
                        >
                          <Card.Header className="d-flex justify-content-between w-100">
                            <div
                              className="header-title header-title"
                              style={{ cursor: "pointer" }}
                            >
                              <h5 className="card-title">Project Materials</h5>
                            </div>
                          </Card.Header>

                          <div className="d-flex align-items-center justify-content-between"></div>
                          <Card.Body className="px-xl-4 px-md-2">
                            <p className="form-label mb-1 d-block">
                              Select Date Range
                            </p>
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div
                                className="position-relative"
                                ref={pickerRef}
                              >
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={() =>
                                    setShowDatePicker(!showDatePicker)
                                  }
                                  disabled={!hasProducts || productsLoader}
                                >
                                  {assignedDateRange.assignDateFrom &&
                                  assignedDateRange.assignDateTo
                                    ? `${assignedDateRange.assignDateFrom} → ${assignedDateRange.assignDateTo}`
                                    : "Select Date Range"}
                                </button>
                                {showDatePicker && (
                                  <div
                                    className="position-absolute bg-white border rounded shadow-sm mt-2"
                                    style={{ zIndex: 1000 }}
                                  >
                                    <DateRange
                                      editableDateInputs={true}
                                      onChange={handleDateRangeSelect}
                                      moveRangeOnFirstSelection={false}
                                      ranges={dateRange}
                                      maxDate={new Date()}
                                    />
                                  </div>
                                )}
                              </div>
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => {
                                  clearDateRangeFilter();
                                  setDateRange([
                                    {
                                      startDate: new Date(),
                                      endDate: new Date(),
                                      key: "selection",
                                    },
                                  ]);
                                }}
                                disabled={!hasProducts || productsLoader}
                              >
                                Clear
                              </button>
                            </div>
                            <Box
                              sx={{
                                gap: { sm: "0rem" },
                                overflow: { sm: "auto" },
                                p: { sm: "4px" },
                                width: { sm: "100%" },
                                marginTop: {
                                  xl: "1rem",
                                  lg: "1rem",
                                  md: "3rem",
                                  sm: "3rem",
                                  xs: "0rem",
                                },
                              }}
                            >
                              <MaterialReactTable table={tableJobProduct} />
                            </Box>
                          </Card.Body>
                        </Col>
                      </Row>
                    )}

                    {!viewProduct && !showHistoryView && (
                      <Row>
                        <Col md={12} sm={12} className="m-0 p-0">
                          <Card.Header className="d-flex justify-content-between">
                            <div className="header-title d-flex">
                              <h5 className="card-title">
                                Product{" "}
                                <span
                                  className="text-gray"
                                  style={{ fontSize: "17px" }}
                                >
                                  {"(" +
                                    selectedItemProduct?.product_name +
                                    ")"}
                                </span>
                              </h5>
                            </div>
                          </Card.Header>

                          <div className="d-flex  align-items-center justify-content-between"></div>
                          <Card.Body className="px-xl-4 px-md-2">
                            <p className="form-label mb-1 d-block">
                              Select Date Range
                            </p>
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div
                                className="position-relative"
                                ref={pickerRef}
                              >
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={() =>
                                    setShowDatePicker(!showDatePicker)
                                  }
                                  disabled={itemsLoader}
                                >
                                  {assignedDateRange.assignDateFrom &&
                                  assignedDateRange.assignDateTo
                                    ? `${assignedDateRange.assignDateFrom} → ${assignedDateRange.assignDateTo}`
                                    : "Select Date Range"}
                                </button>
                                {showDatePicker && (
                                  <div
                                    className="position-absolute bg-white border rounded shadow-sm mt-2"
                                    style={{ zIndex: 1000 }}
                                  >
                                    <DateRange
                                      editableDateInputs={true}
                                      onChange={handleDateRangeSelect}
                                      moveRangeOnFirstSelection={false}
                                      ranges={dateRange}
                                      maxDate={new Date()}
                                    />
                                  </div>
                                )}
                              </div>
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => {
                                  clearDateRangeFilter();
                                  setDateRange([
                                    {
                                      startDate: new Date(),
                                      endDate: new Date(),
                                      key: "selection",
                                    },
                                  ]);
                                }}
                                disabled={!hasProducts || itemsLoader}
                              >
                                Clear
                              </button>
                            </div>
                            <Box
                              sx={{
                                gap: { sm: "0rem" },
                                overflow: { sm: "auto" },
                                p: { sm: "4px" },
                                width: { sm: "100%" },
                                marginTop: {
                                  xl: "1rem",
                                  lg: "1rem",
                                  md: "3rem",
                                  sm: "3rem",
                                  xs: "0rem",
                                },
                              }}
                            >
                              <MaterialReactTable
                                table={tableJobProductItems}
                              />
                            </Box>
                          </Card.Body>
                        </Col>
                        <hr />
                      </Row>
                    )}

                    {showHistoryView && (
                      <Row>
                        <Col md={12} sm={12} className="m-0 p-0">
                          <Card.Header className="d-flex justify-content-between">
                            <div className="header-title d-flex">
                              <h5 className="card-title">
                                Product{" "}
                                <span
                                  className="text-gray"
                                  style={{ fontSize: "17px" }}
                                >
                                  {"(" +
                                    selectedItemProduct?.product_name +
                                    ")"}
                                </span>
                              </h5>
                            </div>
                          </Card.Header>

                          <div className="d-flex align-items-center justify-content-between"></div>
                          <Card.Body className="px-xl-4 px-md-2">
                            <Box
                              sx={{
                                gap: { sm: "0rem" },
                                overflow: { sm: "auto" },
                                p: { sm: "4px" },
                                width: { sm: "100%" },
                                marginTop: {
                                  xl: "1rem",
                                  lg: "1rem",
                                  md: "3rem",
                                  sm: "3rem",
                                  xs: "0rem",
                                },
                              }}
                            >
                              <div
                                style={{
                                  maxHeight: "90vh",
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                  paddingRight: "8px",
                                }}
                              >
                                {selectedHistory &&
                                selectedHistory.length > 0 ? (
                                  <div className="d-flex flex-column align-items-center justify-content-center">
                                    {selectedHistory.map((item) => (
                                      <HistoryCard key={item.id} item={item} />
                                    ))}
                                  </div>
                                ) : (
                                  <div className="text-center text-muted py-3">
                                    <i className="fas fa-history fa-2x mb-2"></i>
                                    <p>No History Available</p>
                                  </div>
                                )}
                              </div>
                            </Box>
                          </Card.Body>
                        </Col>
                      </Row>
                    )}
                  </Card.Body>
                )}
              </Card>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default JobProducts;
